export const initialState = () => ({
	guidedTutorials: [],
	isGuidedTutorialOn: false,
	docsUrl: '',
});

const state = initialState();

export default state;
